/* @flow */

import * as React from 'react';
import Collapse, { Panel } from 'rc-collapse';
import Markdown from 'react-markdown';

type Item = {
  id: string,
  content: string,
  title: string
};

type Props = {
  activeKey?: string,
  items?: Array<Item>,
  name: string,
  onChange: Function
};

const defaultProps = {
  activeKey: undefined,
  items: []
};

function NestedContentSection({ activeKey, items, name, onChange }: Props) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="faq-wrapper">
      <h2>{name}</h2>
      <Collapse accordion activeKey={activeKey} onChange={onChange} prefixCls="faq-collapse">
        {items.map(item => (
          <Panel key={item.id} header={item.title}>
            <Markdown source={item.content} />
          </Panel>
        ))}
      </Collapse>
    </div>
  );
}

NestedContentSection.defaultProps = defaultProps;

export default NestedContentSection;
